/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { ClearableSearchField } from "components/SearchField/SearchField";
import React, { useEffect, useState } from "react";

import {
  AppBar,
  Button,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Tab,
  Tabs,
} from "@mui/material";
import breakpoints from "assets/theme/base/breakpoints";

import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getOrder } from "utils/api";
import { appConstants } from "utils/appConstants";
import { blank, getScreenRight } from "utils/generic";

function CustomerOrder() {
  const [table, setTable] = useState("New");
  const [showNew, setshowNew] = useState(false);
  const [showInprogress, setshowInprogress] = useState(false);
  const [showCompleted, setshowCompleted] = useState(false);
  const [setOthers, setsetOthers] = useState(false);
  const [rows, setRows] = useState([]);
  const [screenName, setScreenName] = useState("Orders");
  const [disableColor, setDisableColor] = useState(false);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const [values, setValues] = React.useState({
    orderNumber: "",
    orderDate: "",
    shipmentType: "",
    paymentType: "",
    senderCity: "",
    receiverCity: "",
    distance: "",
    totalCharges: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
      .businessUserID,
    customerID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))._id,
    searchParameterList: [
      "orderNumber",
      "orderDate",
      "shipmentType",
      "paymentType",
      "senderCity",
      "receiverCity",
      "distance",
      "totalCharges",
      "orderStatus",
      "droppedDateTime",
      "pickedDateTime",
      "jobStatus",
    ],
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const paramValue = urlParams.get("tabValues");
    if (tabValue !== "New") {
      if (paramValue === "inProgress") {
        setTable("inProgress");
      } else if (paramValue === "Completed") {
        setTable("Completed");
      } else if (paramValue === "others") {
        setTable("others");
      }
    }
    getRight();
    sessionStorage.setItem("ROUTE_TYPE", "customer");
  }, []);

  async function getRight() {
    let right = await getScreenRight("Orders");
    if (right === "Full Access") {
      setDisableColor(false);
    } else setDisableColor(true);
  }

  useEffect(() => {
    if (sessionStorage.getItem("PARA_TABLE") === "New") {
      setTable("New");
    } else if (sessionStorage.getItem("PARA_TABLE") === "inProgress") {
      setTable("inProgress");
    } else if (sessionStorage.getItem("PARA_TABLE") === "Completed") {
      setTable("Completed");
    } else if (sessionStorage.getItem("PARA_TABLE") === "others") {
      setTable("others");
    }
    if (table === "New") {
      sessionStorage.removeItem("tableName");
      sessionStorage.setItem("tableName", "New");
      window.history.pushState({}, "", "/orders/customerOrders?tabValues=New");
      setshowNew(true);
      setshowInprogress(false);
      setshowCompleted(false);
      setsetOthers(false);
      setTabValue(0);
    } else if (table === "inProgress") {
      sessionStorage.setItem("tableName", "inProgress");
      window.history.pushState(
        {},
        "",
        "/orders/customerOrders?tabValues=inProgress"
      );
      setshowNew(false);
      setshowInprogress(true);
      setshowCompleted(false);
      setsetOthers(false);
      setTabValue(1);
    } else if (table === "Completed") {
      sessionStorage.setItem("tableName", "Completed");
      window.history.pushState(
        {},
        "",
        "/orders/customerOrders?tabValues=Completed"
      );
      setshowNew(false);
      setshowInprogress(false);
      setshowCompleted(true);
      setsetOthers(false);
      setTabValue(2);
    } else if (table === "others") {
      sessionStorage.setItem("tableName", "others");
      window.history.pushState(
        {},
        "",
        "/orders/customerOrders?tabValues=others"
      );
      setshowNew(false);
      setshowInprogress(false);
      setshowCompleted(false);
      setsetOthers(true);
      setTabValue(3);
    }
    sessionStorage.removeItem("PARA_TABLE");
  }, [table]);

  useEffect(() => {
    fetchOrder(table);
  }, [table, values.sortingType, values.page, values.limit]);

  const fetchOrder = async (type) => {
    values.orderType = type;
    getOrder(
      values,
      (data) => {
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
      },
      dispatch
    );
  };

  const handlePageChange = (page) => {
    values.page = page;
    fetchOrder();
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };
  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const newCol = [
    {
      name: "Order Number",
      selector: (row) => row.orderNumber,
      sortable: true,
      sortField: "orderNumber",
    },
    {
      name: "Order Date Time",
      selector: (row) => row.orderDateFormated,
      sortable: true,
      sortField: "orderDate",
    },
    {
      name: "Shipment Type",
      selector: (row) => row.shipmentType,
      sortable: true,
      sortField: "shipmentType",
    },
    {
      name: "Payment Type",
      selector: (row) => row.paymentType,
      sortable: true,
      sortField: "paymentType",
    },
    {
      name: "Sender City",
      selector: (row) => row.senderCity,
      sortable: true,
      sortField: "senderCity",
    },
    {
      name: "Receiver City",
      selector: (row) => row.receiverCity,
      sortable: true,
      sortField: "receiverCity",
    },
    {
      name: "Shipment Distance",
      selector: (row) => row.distance,
      sortable: true,
      sortField: "distance",
    },
    {
      name: "Total Charges($)",
      selector: (row) => row.totalCharges,
      sortable: true,
      sortField: "totalCharges",
    },
    {
      name: "Order Status",
      selector: (row) => row.orderStatus,
      sortable: true,
      sortField: "orderStatus",
    },

    {
      name: "Driver Job Status",
      selector: (row) => row?.jobStatus,
      sortable: true,
      sortField: "jobStatus",
    },
    {
      name: "Actions",
      selector: (row) => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item style={{ marginLeft: "-20px" }}>
              <Link to={`/orders/vieworders/${row.ID}`}>
                <TimelineItem color="info" icon="visibility" title="View" />
              </Link>
            </Grid>
            {row.orderStatus === "Draft" ? (
              <Grid item>
                <Link to={`/orders/editCustOrders/${row.ID}`}>
                  <TimelineItem
                    color="success"
                    icon="edit"
                    title="Edit Order"
                  />
                </Link>
              </Grid>
            ) : (
              <Grid item>
                <Link to={""}>
                  <TimelineItem color="grey" icon="edit" title="Edit Order" />
                </Link>
              </Grid>
            )}
          </Grid>
        </>
      ),
    },
  ];

  const inprogressCol = [
    {
      name: "Order Number",
      selector: (row) => row.orderNumber,
      sortable: true,
      sortField: "orderNumber",
    },
    {
      name: "Order Date Time",
      selector: (row) => row.orderDateFormated,
      sortable: true,
      sortField: "orderDate",
    },
    {
      name: "Shipment Type",
      selector: (row) => row.shipmentType,
      sortable: true,
      sortField: "shipmentType",
    },
    {
      name: "Payment Type",
      selector: (row) => row.paymentType,
      sortable: true,
      sortField: "paymentType",
    },
    {
      name: "Sender City",
      selector: (row) => row.senderCity,
      sortable: true,
      sortField: "senderCity",
    },
    {
      name: "Receiver City",
      selector: (row) => row.receiverCity,
      sortable: true,
      sortField: "receiverCity",
    },
    {
      name: "Shipment Distance",
      selector: (row) => row.distance,
      sortable: true,
      sortField: "distance",
    },
    {
      name: "Total Charges($)",
      selector: (row) => row.totalCharges,
      sortable: true,
      sortField: "totalCharges",
    },
    {
      name: "Order Status",
      selector: (row) => row.orderStatus,
      sortable: true,
      sortField: "orderStatus",
    },
    {
      name: "Picked Date Time",
      selector: (row) => row.pickedDateTimeFormated,
      sortable: true,
      sortField: "pickedDateTime",
    },
    {
      name: "Driver Job Status",
      selector: (row) => row?.jobStatus,
      sortable: true,
      sortField: "jobStatus",
    },
    {
      name: "Actions",
      selector: (row) => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item ml={-1.2}>
              <Link to={`/orders/vieworders/${row.ID}`}>
                <TimelineItem color="info" icon="visibility" title="View" />
              </Link>
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  const completedCol = [
    {
      name: "Order Number",
      selector: (row) => row.orderNumber,
      sortable: true,
      sortField: "orderNumber",
    },
    {
      name: "Order Date Time",
      selector: (row) => row.orderDateFormated,
      sortable: true,
      sortField: "orderDate",
    },
    {
      name: "Shipment Type",
      selector: (row) => row.shipmentType,
      sortable: true,
      sortField: "shipmentType",
    },
    {
      name: "Payment Type",
      selector: (row) => row.paymentType,
      sortable: true,
      sortField: "paymentType",
    },
    {
      name: "Sender City",
      selector: (row) => row.senderCity,
      sortable: true,
      sortField: "senderCity",
    },
    {
      name: "Receiver City",
      selector: (row) => row.receiverCity,
      sortable: true,
      sortField: "receiverCity",
    },
    {
      name: "Shipment Distance",
      selector: (row) => row.distance,
      sortable: true,
      sortField: "distance",
    },
    {
      name: "Total Charges($)",
      selector: (row) => row.totalCharges,
      sortable: true,
      sortField: "totalCharges",
    },
    {
      name: "Order Status",
      selector: (row) => row.orderStatus,
      sortable: true,
      sortField: "orderStatus",
    },
    {
      name: "Picked Date Time",
      selector: (row) => row.pickedDateTimeFormated,
      sortable: true,
      sortField: "pickedDateTime",
    },
    {
      name: "Dropped Date Time",
      selector: (row) => row?.droppedDateTimeFormated,
      sortable: true,
      sortField: "droppedDateTime",
    },
    {
      name: "Driver Job Status",
      selector: (row) => row?.jobStatus,
      sortable: true,
      sortField: "jobStatus",
    },
    {
      name: "Actions",
      selector: (row) => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item ml={-1.2}>
              <Link to={`/orders/vieworders/${row.ID}`}>
                <TimelineItem color="info" icon="visibility" title="View" />
              </Link>
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  const New = (
    <>
      {showNew && (
        <>
          <MDBox mb={0}>
            <Grid
              container
              display={"flex"}
              justifyContent="end"
              mt={3}
              pt={3}
              pb={3}
              gap={2}
              px={2.2}
            >
              <Grid lg={2.5} xs={6}>
                <ClearableSearchField
                  type="text"
                  variant="outlined"
                  fullWidth
                  className="searchButton"
                  placeholder="Search..."
                  label="Search Filter"
                  value={values.filterValues}
                  onChange={(e) =>
                    setValues({ ...values, filterValues: e.target.value })
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <Button
                          style={{
                            borderRadius: "0px 0.5rem  0.5rem 0px",
                            boxShadow: "none",
                            background: barColor,
                          }}
                          variant="contained"
                          onClick={() => fetchOrder(table)}
                        >
                          <GridSearchIcon color="white" />
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <div style={{ marginRight: "16px" }}>
                <MDButton
                  variant="contained"
                  onClick={
                    disableColor
                      ? blank
                      : () => navigate("/orders/addCustOrder/new")
                  }
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  color={disableColor ? "secondary" : "success"}
                >
                  Add New
                </MDButton>
              </div>
            </Grid>
            <CardContent>
              <BTable
                title={title}
                columns={newCol}
                data={rows}
                selectableRows={false}
                sortingType={handleSort}
                sortServer
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                clearSelectedRows={toggleCleared}
                fixedHeaderScrollHeight="410px"
                fixedHeader={true}
              />
            </CardContent>
          </MDBox>
        </>
      )}
    </>
  );

  const inProgress = (
    <>
      {showInprogress && (
        <>
          <MDBox mb={0}>
            <Grid
              container
              display={"flex"}
              justifyContent="end"
              mt={3}
              pt={3}
              pb={3}
              gap={2}
              px={2.2}
            >
              <Grid lg={2.5} xs={6}>
                <ClearableSearchField
                  type="text"
                  variant="outlined"
                  fullWidth
                  className="searchButton"
                  placeholder="Search..."
                  label="Search Filter"
                  value={values.filterValues}
                  onChange={(e) =>
                    setValues({ ...values, filterValues: e.target.value })
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <Button
                          style={{
                            borderRadius: "0px 0.5rem  0.5rem 0px",
                            boxShadow: "none",
                            background: barColor,
                          }}
                          variant="contained"
                          onClick={() => fetchOrder(table)}
                        >
                          <GridSearchIcon color="white" />
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <CardContent>
              <BTable
                title={title}
                columns={inprogressCol}
                data={rows}
                selectableRows={false}
                sortingType={handleSort}
                sortServer
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                clearSelectedRows={toggleCleared}
                fixedHeaderScrollHeight="410px"
                fixedHeader={true}
              />
            </CardContent>
          </MDBox>
        </>
      )}
    </>
  );

  const completed = (
    <>
      {showCompleted && (
        <>
          <MDBox mb={0}>
            <Grid
              container
              display={"flex"}
              justifyContent="end"
              mt={3}
              pt={3}
              pb={3}
              gap={2}
              px={2.2}
            >
              <Grid lg={2.5} xs={6}>
                <ClearableSearchField
                  type="text"
                  variant="outlined"
                  fullWidth
                  className="searchButton"
                  placeholder="Search..."
                  label="Search Filter"
                  value={values.filterValues}
                  onChange={(e) =>
                    setValues({ ...values, filterValues: e.target.value })
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <Button
                          style={{
                            borderRadius: "0px 0.5rem  0.5rem 0px",
                            boxShadow: "none",
                            background: barColor,
                          }}
                          variant="contained"
                          onClick={() => fetchOrder(table)}
                        >
                          <GridSearchIcon color="white" />
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <CardContent>
              <BTable
                title={title}
                columns={completedCol}
                data={rows}
                selectableRows={false}
                sortingType={handleSort}
                sortServer
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                clearSelectedRows={toggleCleared}
                fixedHeaderScrollHeight="410px"
                fixedHeader={true}
              />
            </CardContent>
          </MDBox>
        </>
      )}
    </>
  );

  const others = (
    <>
      {setOthers && (
        <>
          <MDBox mb={0}>
            <Grid
              container
              display={"flex"}
              justifyContent="end"
              mt={3}
              pt={3}
              pb={3}
              gap={2}
              px={2.2}
            >
              <Grid lg={2.5} xs={6}>
                <ClearableSearchField
                  type="text"
                  variant="outlined"
                  fullWidth
                  className="searchButton"
                  placeholder="Search..."
                  label="Search Filter"
                  value={values.filterValues}
                  onChange={(e) =>
                    setValues({ ...values, filterValues: e.target.value })
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <Button
                          style={{
                            borderRadius: "0px 0.5rem  0.5rem 0px",
                            boxShadow: "none",
                            background: barColor,
                          }}
                          variant="contained"
                          onClick={() => fetchOrder(table)}
                        >
                          <GridSearchIcon color="white" />
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <CardContent>
              <BTable
                title={title}
                columns={newCol}
                data={rows}
                selectableRows
                sortingType={handleSort}
                sortServer
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                clearSelectedRows={toggleCleared}
                fixedHeaderScrollHeight="410px"
                fixedHeader={true}
              />
            </CardContent>
          </MDBox>
        </>
      )}
    </>
  );

  const renderTable = () => {
    return (
      <>
        {New}
        {inProgress}
        {completed}
        {others}
      </>
    );
  };
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Height val={30} />
      <Card>
        <PageTitle screenName={screenName} />
        <Grid container>
          <Grid item xs={12} md={6} lg={6} px={2} mb={-3.5}>
            <AppBar position="inherit">
              <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={handleSetTabValue}
                indicatorColor={"primary"}
                sx={{
                  "& .Mui-selected": {
                    color: "#fff !important",
                    background: `${barColor} !important`,
                  },
                  ".MuiTabs-indicator": {
                    background: `${barColor} !important`,
                  },
                }}
              >
                <Tab
                  onClick={() => {
                    setTable("New");
                    setValues((prevValues) => ({
                      ...prevValues,
                      sortingType: "",
                      sortingField: "",
                      filterValues: "",
                      page: appConstants.page,
                      limit: appConstants.limit,
                    }));
                  }}
                  label="New"
                />
                <Tab
                  onClick={() => {
                    setTable("inProgress");
                    setValues((prevValues) => ({
                      ...prevValues,
                      sortingType: "",
                      sortingField: "",
                      filterValues: "",
                      page: appConstants.page,
                      limit: appConstants.limit,
                    }));
                  }}
                  label="In Progress"
                />
                <Tab
                  onClick={() => {
                    setTable("Completed");
                    setValues((prevValues) => ({
                      ...prevValues,
                      sortingType: "",
                      sortingField: "",
                      filterValues: "",
                      page: appConstants.page,
                      limit: appConstants.limit,
                    }));
                  }}
                  label="Completed"
                />
                <Tab
                  onClick={() => {
                    setTable("others");
                    setValues((prevValues) => ({
                      ...prevValues,
                      sortingType: "",
                      sortingField: "",
                      filterValues: "",
                    }));
                  }}
                  label="Others"
                />
              </Tabs>
            </AppBar>
          </Grid>
        </Grid>
        {renderTable()}
      </Card>
    </DashboardLayout>
  );
}

export default CustomerOrder;
